export default __webpack_public_path__ + "static/media/ReferralInvitesBanner.a474e5a3.png";